// import { TranslationData } from '../translation'

import { FREE_BENEFITS, PRO_BENEFITS, PRO_V_BENEFITS } from '../../../services/userService/const'

const EN_TRANSLATION = {
  buyModal: {
    afterFree: 'After your free trial',
    btn: 'Try It Free',
    freeTrial: '3-Day Free Trial',
    monthLabel: 'month',
    selectLabel: 'Select a plan',
    title: 'Subscription Plan',
    yearLabel: 'year',
  },
  contact: {
    block1:
      "For customization, questions, or suggestions, please contact us at contact@noam.tools. We'll respond promptly.",
    block2: 'Support us by rating us on the Google Apps Extension store at ★★★★★.',
    block3: 'Help others by sharing this extension:',
    title: 'Contact Us',
  },
  help: {
    AquickOverviewOfNoam: 'A Quick Overview of Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Favorites Management',
    Fixedplugin: 'Fixed Plugin',
    Focusing: 'Focusing',
    Free: 'Free',
    FreeTrialBenefits: 'Free Trial Benefits',
    GoWithWikipedia: 'Go with Wikipedia',
    GoWithYouTube: 'Go with YouTube',
    HoverTranslation: 'Hover Translation',
    Howtouse: 'How to Use',
    ImageTranslation: 'Image Translation',
    InstantTranslation: 'Instant Translation',
    Membership: 'Membership',
    NoamHelp: 'Noam helps you translate and summarize',
    PDFparallelTranslation: 'PDF Parallel Translation',
    ParallelTranslation: 'Parallel Translation',
    SkipAllSteps: 'Skip All Steps',
    Summary: 'Summary',
    Translation: 'Translation',
    TryItForFree: 'Try It For Free',
    Video: 'Video',
    VideoSummary: 'Video Summary',
    VideoTranslation: 'Video Translation',
    WebSummary: 'Web Summary',
    WordSelectionTranslation: 'Word Selection Translation',
    benefits: 'We have benefits waiting for you!',
    dayFree: '3-Day Free Trial',
    done: 'Done',
    next: 'Next',
    pin: 'Pin Noam for Easier Access～～',
    planIsNotExist: 'Plan is not available',
    startWiki: "Let's start with Wikimedia!",
    startYoutube: "Let's start with YouTube!",
    try: 'Try It Out',
    tryNow: 'Give it a try now!',
  },
  home: {
    PDFTranslate: {
      desc: 'Bilingual Translation + Chat PDF',
      sub1: {
        desc: 'Bilingual reading lets you compare the original text and the translation side-by-side, improving reading efficiency.',
        title: 'Bilingual Reading',
      },
      sub2: {
        desc: 'AI analyzes and summarizes, and can answer your questions based on the PDF content.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-powered PDF translation for greater accuracy and efficiency.',
        title: 'Accuracy and Efficiency',
      },
      title: 'PDF Translate',
    },
    aiAssistant: {
      desc: 'Making Web Translation Smarter and More Convenient',
      panel1: {
        desc: 'Bilingual cross-referencing translations help you compare the original text with the translation so you can understand better and improve your reading efficiency.',
        title: 'Bilingual Translation',
      },
      panel2: {
        left: {
          desc: 'When browsing a web page, hover over the content you need to translate to see the translation.',
          title: 'Hover Translation',
        },
        right: {
          desc: 'When browsing a web page, select the text you want to translate to see the translation.',
          title: 'Text Selection Translation',
        },
      },
      panel3: {
        one: {
          desc: 'Translate and summarize web pages and video content anytime, anywhere, for a smoother experience!',
          title: 'Point and Click',
        },
        three: {
          desc: 'AI-driven large language model ensures translation accuracy and consistency for an enhanced reading experience.',
          title: 'AI-Driven',
        },
        two: {
          desc: 'Multi-language full coverage, bilingual barrier-free reading, one-click translation - experience the difference!',
          title: 'More Comprehensive and Convenient',
        },
      },
      panel4: {
        tab1: {
          desc: 'Your efficiency expert - using ChatGPT, Noam translates and summarizes YouTube video content to save you time!',
          key: 'Video',
          title: 'Video Translation & Summary',
        },
        tab2: {
          desc: 'Click to translate images while browsing the web.',
          key: 'Image',
          title: 'Image Translate',
        },
        tab3: {
          desc: 'Instantly extracts key information from web pages and provides a summary, enhancing your reading efficiency.',
          key: 'Web',
          title: 'Web Translate & Summary',
        },
        tag1: 'Simple',
        tag2: 'Efficient',
        tag3: 'Easy to Understand',
      },
      title: 'AI Assistant',
    },
    getStart: 'Get Started',
    getStartedForFree: 'Get started for free',
    howItWork: {
      desc: 'Noam integrates AI models to provide users with an intelligent experience for cross-language web page translation and summarization, PDF and image translation, video translation and summarization',
      title: 'How it works',
    },
    lastBlock: {
      desc: 'Better AI translation for a smoother reading experience',
    },
    top: {
      desc: 'Noam is a free AI browser extension that helps you translate and summarize web pages, videos, and PDF content.\\n      Join Noam and experience the magic!',
      title1: 'One Magic',
      title2: 'One Click',
    },
    userReviews: {
      desc: 'Five-star reviews on the Chrome Web Store',
      title: 'User Reviews',
    },
  },
  installTips: {
    btn: 'Try It Now',
    text: 'Install "Noam Browser Plugin" to unlock more features! Web cross-referencing,\\n    web video summarization, and more!',
  },
  locale: {
    af: 'Afrikaans',
    am: 'Amharic',
    ar: 'Arabic',
    as: 'Assamese',
    auto: 'Auto detect',
    az: 'Azerbaijani',
    ba: 'Bashkir',
    bg: 'Bulgarian',
    bn: 'Bangla',
    bo: 'Tibetan',
    bs: 'Bosnian',
    ca: 'Catalan',
    cs: 'Czech',
    cy: 'Welsh',
    da: 'Danish',
    de: 'German',
    dsb: 'Lower Sorbian',
    dv: 'Divehi',
    el: 'Greek',
    en: 'English',
    es: 'Spanish',
    et: 'Estonian',
    eu: 'Basque',
    fa: 'Persian',
    fi: 'Finnish',
    fil: 'Filipino',
    fj: 'Fijian',
    fr: 'French',
    frCA: 'French (Canada)',
    ga: 'Irish',
    gl: 'Galician',
    gom: 'Konkani',
    gu: 'Gujarati',
    ha: 'Hausa',
    he: 'Hebrew',
    hi: 'Hindi',
    hr: 'Croatian',
    hsb: 'Upper Sorbian',
    ht: 'Haitian Creole',
    hu: 'Hungarian',
    hy: 'Armenian',
    id: 'Indonesian',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'Icelandic',
    it: 'Italian',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (Latin)',
    ja: 'Japanese',
    ka: 'Georgian',
    kk: 'Kazakh',
    km: 'Khmer',
    kmr: 'Kurdish (Northern)',
    kn: 'Kannada',
    ko: 'Korean',
    ku: 'Kurdish (Central)',
    ky: 'Kyrgyz',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'Lithuanian',
    lug: 'Ganda',
    lv: 'Latvian',
    lzh: 'Chinese (Literary)',
    mai: 'Maithili',
    mg: 'Malagasy',
    mi: 'Māori',
    mk: 'Macedonian',
    ml: 'Malayalam',
    mnCyrl: 'Mongolian (Cyrillic)',
    mnMong: 'Mongolian (Traditional)',
    mr: 'Marathi',
    ms: 'Malay',
    mt: 'Maltese',
    mww: 'Hmong Daw',
    my: 'Myanmar (Burmese)',
    nb: 'Norwegian',
    ne: 'Nepali',
    nl: 'Dutch',
    noSearchLang: 'Language not supported',
    nso: 'Sesotho sa Leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'Punjabi',
    pl: 'Polish',
    placeholder: 'Search',
    prs: 'Dari',
    ps: 'Pashto',
    pt: 'Portuguese (Brazil)',
    ptPT: 'Portuguese (Portugal)',
    ro: 'Romanian',
    ru: 'Russian',
    run: 'Rundi',
    rw: 'Kinyarwanda',
    sd: 'Sindhi',
    si: 'Sinhala',
    sk: 'Slovak',
    sl: 'Slovenian',
    sm: 'Samoan',
    sn: 'Shona',
    so: 'Somali',
    sq: 'Albanian',
    srCyrl: 'Serbian (Cyrillic)',
    srLatn: 'Serbian (Latin)',
    st: 'Sesotho',
    sv: 'Swedish',
    sw: 'Swahili',
    ta: 'Tamil',
    te: 'Telugu',
    th: 'Thai',
    ti: 'Tigrinya',
    tk: 'Turkmen',
    tlhLatn: 'Klingon (Latin)',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Setswana',
    to: 'Tongan',
    tr: 'Turkish',
    tt: 'Tatar',
    ty: 'Tahitian',
    ug: 'Uyghur',
    uk: 'Ukrainian',
    ur: 'Urdu',
    uz: 'Uzbek (Latin)',
    vi: 'Vietnamese',
    xh: 'Xhosa',
    yo: 'Yoruba',
    yua: 'Yucatec Maya',
    yue: 'Cantonese (Traditional)',
    zh: 'Chinese',
    zhHans: 'Chinese Simplified',
    zhHant: 'Chinese Traditional',
    zu: 'Zulu',
  },
  login: {
    and: ' and ',
    btn: 'Log In with Google',
    btn1: 'Log In Now',
    desc: 'Log in to unlock more experiences',
    policy: 'Privacy Policy',
    terms: 'Terms of Use',
    tips: 'By signing up, I agree to the ',
    title: 'Welcome to Noam',
  },
  pageFooter: {
    follow: {
      facebook: 'Facebook',
      title: 'Follow',
      twitter: 'Twitter',
    },
    legal: {
      policy: 'Privacy Policy',
      terms: 'Terms of Service',
      title: 'Legal',
    },
    product: {
      image: 'Image Translation',
      pdf: 'PDF Translation',
      title: 'Products',
      video: 'Video Translation & Summary',
      web: 'Web Translation & Summary',
    },
    resources: {
      title: 'Resources',
    },
    tools: {
      title: 'Tools',
      pdf: 'PDF Translation',
    },
  },
  pageHeader: {
    contact: 'Contact',
    help: 'Help',
    logout: 'Log Out',
    logoutSucc: 'Logged out.',
    pricing: 'Pricing',
    settings: 'Settings',
    signUp: 'Log In',
  },
  pdf: {
    autoDetect: 'Auto-Detect',
    cancelBtn: 'Cancel',
    cancelUpload: 'Cancel',
    chatPdf: {
      summaryError: 'Summary failed, please try again later',
      chatError: 'Chat failed, please try again later',
      Search: 'Search',
      cancel: 'Cancel',
      chatTitle: "Welcome to Noam! Here's a summary of your PDF:",
      clear: 'Clear',
      clearContent:
        "This will start a new conversation. The current conversation won't be saved. Are you sure?",
      clearDialogTitle: 'Please Confirm',
      clearSucc: 'Cleared',
      copy: 'Copy',
      copySucc: 'Copied',
      delete: 'Delete',
      deleteCancel: 'Cancel',
      deleteContent: 'This PDF cannot be recovered once deleted. Are you sure?',
      deleteOk: 'Delete',
      deleteSuccess: 'Deleted',
      deleteTitle: 'Confirm Delete',
      expand: 'Collapse',
      historyTitle: 'History',
      listError: 'Failed to load reading list. Please try again later, or contact support.',
      loading: 'Loading...',
      noDataDesc: 'No history yet.',
      noMore: 'No more content.',
      placeholder: 'Ask anything about this PDF',
      summaryTitle: 'You might be interested in these questions:',
    },
    collectionEmpty: 'Your collection is empty.',
    collectionTab: 'Notes',
    dataLoading: 'Loading...',
    dialogContent: 'Are you sure you want to delete this?',
    dialogTitle: 'Please Confirm',
    download: {
      both: 'Bilingual',
      btn: 'Save',
      cancel: 'Closing this window will cancel the PDF download. Are you sure you want to cancel?',
      desc: 'Save to Device: Downloads translations as images; Save & Print: Downloads translations in the original format, with copy support.',
      download: 'Download',
      downloadMsg1: 'PDF Translation Progress:',
      downloadMsg2: 'Estimated Time Remaining:',
      downloadSucc: 'PDF is ready! Click to save.',
      downloadTip: "Downloading PDF. Don't close this window to avoid download errors.",
      error: 'Failed to save. Try printing instead.',
      fileName: 'File Name:',
      fileType: 'File Type:',
      loading: 'Saving...',
      loading2: 'Loading...',
      minute: 'Minutes...',
      msg1: 'Some translations in this document are longer than the original text, and may overlap in the downloaded file. We recommend reading on the webpage.',
      msg2: '1. Translation is not yet complete. Please download after the translation is finished.',
      msg3: '2. Some translations are too long. Read on the webpage to avoid text overlap.',
      msg4: "Translation tasks are in progress. Please try again after they're completed.",
      progress:
        'Translating PDF. Progress: {{progress}}, Estimated time remaining: {{minutes}} minutes...',
      save: 'Save to Device',
      savePrint: 'Save & Print',
      success: 'Downloaded',
      trans: 'Translation Only',
      transContinue: 'Continue Translating',
    },
    downloadBtn: 'Download',
    dragTipModal: {
      black: 'space',
      leftKey: 'left button',
      ok: 'Got It',
      press: 'Press',
      tips: 'to drag and view.',
    },
    entry: 'PDFs',
    fileErrMsg: 'File reading failed. Please try again later, or contact support.',
    fileMsg: 'Current file size:',
    fileMsg2: 'Please upload a file smaller than 300MB.',
    freeBannerBtn: 'Upgrade',
    freeBannerTips: 'Free PDF Translations Limit Reached',
    guide: {
      placeholder: 'Paste the PDF link here',
      start: 'Start Translating',
      text1: 'Bilingual Reading',
      text2:
        'Read bilingually to compare the original text and translation side-by-side, improving your efficiency.',
      text3: 'Chat With Your PDF',
      text4:
        'AI-powered analysis and summarization. Ask questions about your PDF, and get instant answers.',
      text5: 'Accurate & Efficient',
      text6: 'AI-powered PDF translation for greater accuracy and efficiency.',
      title1: 'Bilingual Translation',
      title2: 'Chat With Your PDF',
      toast: 'Please enter a valid online PDF link ending in .pdf',
    },
    hasTransTask: 'A translation task is in progress. Please wait.',
    hoverTrans: 'Hover-to-Translate Paragraphs',
    initial: 'Translate PDF',
    installText: 'Your one-stop solution for everyday translations.',
    installText2: 'Please install the extension first',
    installTips:
      'Install the extension for even more PDF translations, and smoother website translations:',
    kw: 'staple',
    link: 'link',
    listError: 'Failed to load PDFs. Please try again later, or contact support.',
    memoTotalCount: '1 item total',
    new: 'new file',
    noId: 'File ID not found.',
    notPdf: 'PDF files only.',
    okBtn: 'Delete',
    okBtn2: 'Got It',
    original: 'Original',
    parallel: 'Parallel',
    parseErrDialogContent:
      'This PDF link cannot be translated directly. Please download the PDF and upload it for translation.',
    parseErrTips: 'Failed to parse file',
    parseFileToast: 'Failed to parse file. Please try again later, or contact support.',
    pdfLoading: 'Parsing...',
    searchPlaceholder: 'Search',
    selectTrans: 'Select Text to Translate',
    shareBtn: 'Share',
    shareBtnText1: 'Generate Share Link',
    shareBtnText2: 'Update Shared Content',
    shareModal: {
      cancel: 'Cancel',
      copy: 'Copy',
      copySucc: 'Link Copied',
      custom: 'Customize:',
      errMsg:
        "The selected content hasn't been fully translated yet. Please translate before sharing.",
      gen: 'Share',
      modify: 'Edit',
      notSupport: 'This language is not currently supported.',
      page: 'Pages',
      pageNuErr: 'Please enter a valid page number.',
      range: 'Scope:',
      remain: 'remaining',
      remain1: 'Total estimated time:',
      search: 'Search',
      settings: 'Share Settings:',
      shareSetting: 'Share Settings',
      shareText: 'Share',
      shareTips: 'Share the translated PDF link with your friends:',
      sourceLang: 'From:',
      target: 'To:',
      text1: 'Share Settings',
      text2: 'Generate Share Link',
      totalPage: '1 page total',
      trans: 'Translate',
      translateTips:
        'Tip: If the translation is taking a while, you can close this window and share later.',
      translating: 'Translating PDF...',
      update: 'Update Share Link',
    },
    shareMsg1: 'Share link generated.',
    shareMsg2: 'Shared content updated.',
    shareMsg3: 'Failed to generate share link. Please try again later, or contact support.',
    shareMsg4: 'Failed to update shared content. Please try again later, or contact support.',
    shareTips: 'Your PDF translation is ready! Share it with your friends.',
    start: 'Start Your Free Trial',
    thumbnail: 'Table of Contents',
    toast1: 'Loading PDF. Please try again later.',
    toast2: 'PDF content is being processed. Dialog is currently unsupported.',
    toast3: 'Downloading. Please try again after the download is finished.',
    toolbar: {
      Adjust: 'Adjust',
      autoFit: 'Auto-Fit',
    },
    trans: 'Translation',
    transSucc: 'Translation successful!',
    unLoginToast: 'Please log in to use this feature.',
    uploadBtn: 'Upload',
    uploadErr: 'File upload failed. Please try again later, or contact support.',
    uploadErrSignUrl: 'Failed to get upload URL. Please try again later, or contact support.',
    uploadMsg1: 'Drag & drop your file here.',
    uploadMsg2: 'Supported File Types: PDF  |  Max File Size: 300MB',
    uploadMsg3: 'Click to select or drag & drop files here.',
    uploading: 'Uploading',
    uploadingMsg: 'Uploading. Please wait.',
    uploadingMsg1: 'File is uploading. Please try again later.',
    uploadingMsg2: 'A file is currently being converted. Please try again later.',
    uploadingMsg3:
      'Conversion progress request failed. Please try again later, or contact support.',
    uploadingMsg4: "Noam can't access local files. Please manually upload a PDF for translation.",
    uploadingMsg5: 'Failed to retrieve file URL. Please try again later, or contact support.',
    video: 'video',
    vipBannerBtn: 'Upgrade',
    vipBannerTips: "You've reached your PDF translation limit for this month.",
    webTrans: 'Full Cross-Reference',
  },
  pricing: {
    FAQ: 'FAQ',
    FQAObj: {
      a1: 'Yes, Noam offers a free plan you can use right away.',
      a2: 'We offer three membership plans: Pro, Pro+, and Enterprise. You can choose to pay monthly or annually. Annual billing offers significant savings.',
      a3: 'All features are available on both plans. The main difference is the cost: annual subscriptions cost less overall. Monthly subscriptions are billed each month, while annual plans are billed once per year.',
      a4: 'You can cancel your subscription anytime in your Account Settings.',
      q1: 'Is there a free plan?',
      q2: 'What pricing plans and payment options are available?',
      q3: "What's the difference between subscribing monthly vs. annually?",
      q4: 'How do I cancel my subscription?',
    },
    around: 'Around',
    billedMonthly: 'Billed Monthly',
    billedYearly: 'Billed Yearly',
    day: 'day',
    desc: 'Compare Plans & Choose the Best',
    detailedCompare: 'Compare Plans',
    discount: '20% Off',
    enterprise: {
      benefit1: 'Priority Customer Support',
      benefit2: 'Multiple Users',
      benefit3: 'Tailored Solutions',
      benefit5: 'Dedicated Account Manager',
      btn: 'Contact Us',
      recommendText: 'Custom Plans（≥3人）',
      talkToUs: 'Get in Touch',
    },
    free: {
      benefit1: `Instant translation ${FREE_BENEFITS.realTimeCount} times/day`,
      benefit2: 'Website Translation & Summary',
      benefit3: `${FREE_BENEFITS.imageCount} Image Translations`,
      benefit4: 'Video Translation & Summary',
      benefit5: `${FREE_BENEFITS.pdfUploadCount} PDF Translations`,
      benefit6: `${FREE_BENEFITS.tokenCount} tokens`,
      btn: 'Try It Free',
      recommendText: 'Free Trial',
    },
    imageTranslation: 'Image Translation',
    month: 'month',
    monthly: 'Monthly',
    pageTitle: 'Pricing',
    pdf: {
      chat: 'PDF Chat Queries',
      maxPage: 'Max. Pages per PDF',
      translation: 'PDF Translation',
    },
    preMonth: 'Per month',
    pro: {
      benefit1: 'Priority Customer Support',
      benefit2: `${PRO_BENEFITS.tokenCount} tokens/month`,
      benefit3: 'Website Translation & Summary',
      benefit4: `${PRO_BENEFITS.imageCount} Image Translations`,
      benefit5: 'Video Translation & Summary',
      benefit6: `${PRO_BENEFITS.pdfUploadCount} PDF Translations`,
      btn: 'Get Started',
      recommendText: 'Most Popular',
    },
    proPlus: {
      benefit1: 'Priority Customer Support',
      benefit2: `${PRO_V_BENEFITS.tokenCount} tokens/month`,
      benefit3: 'Website Translation & Summary',
      benefit4: `${PRO_V_BENEFITS.imageCount} Image Translations`,
      benefit5: 'Video Translation & Summary',
      benefit6: `${PRO_V_BENEFITS.pdfUploadCount} PDF Translations`,
      recommendText: 'Best Value',
    },
    video: {
      summary: 'Video Summary',
      translation: 'Video Translation',
    },
    web: {
      contrastiveTranslation: 'Bilingual Translation',
      dictionaryTranslation: 'Selection Translation',
      hoverTranslation: 'Hover Translation',
      instantTranslation: 'Instant Translation',
      summary: 'Web Page Summary',
    },
    yearly: 'Yearly',
  },
  privacy: {
    block1:
      'Noam ("Noam," "we," "our," or "us") respects your privacy and is committed to protecting any information we obtain from you or about you. This Privacy Policy describes our practices regarding the collection or use of personal information from your use of our website, applications, and services (collectively, the "Services"). This Privacy Policy does not apply to the content we handle on behalf of our business product customers, such as our API. The use of this data is subject to our customer agreement, which covers access to and use of these products.',
    block10:
      "We implement commercially reasonable technical, administrative, and organizational measures to protect online and offline personal information from loss, misuse, and unauthorized access, disclosure, alteration, or hostile acts. However, no internet or email transmission can guarantee complete security or accuracy. In particular, emails sent to us or from us may not be secure. So, you should be particularly careful when deciding what information to send to us through the service or email. Additionally, we are not responsible for any obstruction of privacy settings or security measures in the service or Third Party Websites' security settings or security measures. We will retain your personal information for as long as necessary for us to provide you with services or for other legitimate business purposes, such as resolving disputes, security and safety reasons, or complying with our legal obligations. The length of time we retain personal information will depend on many factors, such as the amount, nature, sensitivity of the information, the potential risks of unauthorized use or disclosure, the purposes for which we process the information, and other legally binding considerations.",
    block11:
      'We may update this Privacy Policy from time to time. When we do so, we will post an updated version on this page, unless otherwise required by applicable law.',
    block12:
      'If you have any unanswered questions or concerns about this Privacy Policy, please contact our customer service. Email: ',
    block2:
      'We collect the following personal information ("Personal Information") related to you:',
    block3:
      'Information Provided by You: When you create an account to use our services or communicate with us, we collect personal information as follows:',
    block4:
      'Personal Information Automatically Received from Your Use of Services: When you access, use, or interact with the services, we receive the following information about your access, use, or interaction ("Technical Information"):',
    block5: 'We may use personal information for the following purposes:',
    block6:
      'Summary or De-identified Information: We may aggregate or de-identify personal information to prevent its reuse for identification purposes and use such information to analyze the effectiveness of our services, improve and add features to our services, conduct research, and for similar purposes. Additionally, we may analyze the general behavior and characteristics of our service users and share aggregated information with third parties, publish such aggregated information, or make it generally available. We may collect aggregated information through the services, through cookies, and through other means described in this Privacy Policy. We will maintain and use de-identified information in an anonymous or de-identified form, and we will not attempt to re-identify such information unless required by law.',
    block7:
      'In certain cases, we may provide your personal information to third parties without further notice to you, unless required by law:',
    block8:
      'Depending on your geographic location, individuals in the European Economic Area, the United Kingdom, and globally may have certain statutory rights regarding their personal information. For example, you may have the right to:',
    block9:
      'The service may contain links to other websites not operated or controlled by Noam, including social media services ("Third Party Websites"). The information you share with Third Party Websites will be governed by the specific privacy policies and terms of service of the Third Party Websites, not by this Privacy Policy. We provide these links for convenience and do not imply our endorsement or review of these websites. Please contact Third Party Websites directly for information about their privacy policies and terms.',
    subBlock1:
      'Account Information: When you create an account on our platform, we collect information related to your account, including your name, contact information, account credentials, payment card information, and transaction history ("Account Information").',
    subBlock10: 'Providing, managing, maintaining, and/or analyzing services;',
    subBlock11: 'Communicating with you;',
    subBlock12: 'Developing new products and services;',
    subBlock13:
      'Preventing fraud, criminal activity, or misuse of our services, and protecting the security of our IT systems, architecture, and networks;',
    subBlock14: 'Conducting business transfers;',
    subBlock15:
      'Complying with legal obligations and legal proceedings, protecting our rights, privacy, security, or property, as well as those of our affiliates, you, or other third parties.',
    subBlock16:
      'Suppliers and Service Providers: To assist us in meeting business operational needs and performing certain services and functions, we may provide personal information to suppliers and service providers, including hosting service providers, cloud service providers, and other information technology service providers, email communication software, and web analytics service providers, etc. These partners will access, process, or store personal information only at our direction while performing their duties for us.',
    subBlock17:
      'Business Transfers: If we engage in strategic transactions, reorganizations, bankruptcies, bankruptcy takeovers, or services transition to another provider (collectively, "Transactions"), your personal information and other information may be shared with transaction counterparts and other parties assisting in the Transactions during due diligence and transferred as part of the Transactions along with other assets to a successor or affiliate company.',
    subBlock18:
      'Legal Requirements: We may share your personal information with government authorities, industry peers, or other third parties, including your interaction information with our services, (1) if required by law or if we believe such action is necessary to comply with legal obligations; (2) to protect and defend our rights or property; (3) if we unilaterally determine that there is a violation of our terms, policies, or laws; (4) to detect or prevent fraud or other illegal activities; (5) to protect our products, employees, or users, or public safety, security, integrity; or (vi) to defend against legal liability.',
    subBlock19: 'Access your personal information and information about how it is processed.',
    subBlock2:
      'User Content: When you use our services, we collect personal information from your inputs, file uploads, or feedback provided to us ("Content").',
    subBlock20: 'Request deletion of your personal information from our records.',
    subBlock21: 'Correct or update your personal information.',
    subBlock22: 'Transfer your personal information to a third party (data portability).',
    subBlock23: 'Limit how we process your personal information.',
    subBlock24:
      'Withdraw your consent—where we rely on consent as the legal basis for processing, you can withdraw your consent at any time.',
    subBlock25: 'Object to how we process your personal information.',
    subBlock26: 'Improving our services and conducting research;',
    subBlock3:
      'Communication Information: If you send us messages, we will collect your name, contact information, and the content of your messages ("Communication Information").',
    subBlock4:
      'Social Media Information: We have pages on social media websites such as Instagram, Facebook, Medium, Twitter, YouTube, and LinkedIn. When you interact with our social media pages, we collect the personal information you choose to provide to us, such as your contact details ("Social Information"). Additionally, the companies hosting our social media pages may provide us with aggregated information and analysis about our social media activities.',
    subBlock5:
      'Log Data: Information automatically sent by your browser when using our services. Log data includes your Internet Protocol (IP) address, browser type and settings, the date and time of your requests, and how you interact with our website.',
    subBlock6:
      'Usage Data: We may automatically collect information about your use of the service, such as the types of content you view or interact with, the features you use, the actions you take, as well as your time zone, country, date and time of access, user agent and version, computer or mobile device type, and your computer connection.',
    subBlock7:
      "Device Information: This includes the device's name, operating system, device identifier, and the browser you are using. The information collected may depend on the type of device you are using and its settings.",
    subBlock8:
      'Cookies: We use cookies to operate and manage our services and improve your experience. A "cookie" is information sent by a website you visit to your browser. You can set your browser to accept all cookies, reject all cookies, or notify you when a cookie is provided so that you can decide whether to accept it each time. However, refusing cookies may prevent you from using or negatively affect the display or functionality of certain areas or features of the website. For more information about cookies, please visit All About Cookies.',
    subBlock9:
      'Analytics: We may use various online analytics products that use cookies to help us analyze how users use our services and improve your experience when using the services.',
    subTitle1: 'Personal Information We Collect',
    subTitle2: 'How We Use Personal Information',
    subTitle3: 'Disclosure of Personal Information',
    subTitle4: 'Your Rights',
    subTitle5: 'Links to Other Websites',
    subTitle6: 'Security and Retention of Information',
    subTitle7: 'Modification of Privacy Policy',
    subTitle8: 'How to Contact Us',
    title: 'Privacy Policy',
    updateTime: 'Updated: March 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Accept All',
    text: 'To improve your experience, we use cookies to personalize content and services.',
    title: 'This website uses cookies',
  },
  slogen: 'The easiest AI assistant',
  stripe: {
    contact: 'Contact us at contact@noam.tools  with any questions!',
    fail: {
      btn: 'Retry',
      text1: "We couldn't process your payment.",
      text2: 'Check your connection and try again.',
      title: 'Payment failed',
    },
    succ: {
      btn: "Let's Go",
      text1: 'Welcome to Noam, ',
      text2: "let's get started!",
      title: 'Congratulations',
    },
  },
  terms: {
    block1: 'Thank you for using Noam!',
    block10:
      '(a) Fees and Billing. You will pay all fees ("Fees") according to the pricing and terms on the applicable pricing page or as agreed upon in writing between us. We reserve the right to correct pricing errors or mistakes even if we have issued invoices or received payment. You will provide complete and accurate billing information, including a valid and authorized payment method. We will charge your payment method on a periodic basis as agreed upon, but we may reasonably change the billing date. You authorize Noam, its affiliates, and third-party payment processors to charge your payment method. If your payment fails, we will provide you with written notice and may suspend access to the Service until payment is received. Except as otherwise specified in this agreement, payments are non-refundable.',
    block11:
      '(b) Taxes. Unless otherwise stated, Fees do not include any federal, state, local, and foreign taxes, duties, and similar assessments ("Taxes"). You are responsible for all Taxes associated with your purchases, excluding Taxes based on our net income for which we will invoice you. You agree to promptly pay such Taxes and provide us with legally valid privacy statements and obtain necessary consents for handling such data, and you warrant to us that you handle such data in accordance with applicable law.',
    block12:
      '(c) Price Changes. We may change our prices by notifying you through your account and/or our website. Price increases will be effective immediately upon posting. Any price changes will apply to Fees for your account after the effective date of the change.',
    block13:
      '(d) Disputes and Overdue Payments. If you wish to dispute any Fees or Taxes, please contact contact@noam.tools within thirty (30) days of the invoice date.',
    block14:
      '(e) Free Usage. You may not create multiple accounts to obtain free credits. If we determine that you are not using the free credits in good faith, we may charge you standard fees or stop providing access to the Service.',
    block15:
      '(a) Confidentiality. You may have access to confidential information of Noam. You may only use confidential information as permitted under these terms for the purpose of using the Service. You may not disclose confidential information to any third party, and you will protect confidential information in a manner no less protective than you protect your own similar confidential information, at least with reasonable care. Confidential information is non-public information designated as confidential by Noam or that should reasonably be treated as confidential under the circumstances, including software, specifications, and other non-public business information. Confidential information does not include information that: (1) becomes generally available to the public without fault on your part; (2) you had in your possession without any obligation of confidentiality before receiving it under these terms; (3) is lawfully disclosed to you by a third party without any confidentiality obligations; or (4) is independently developed by you without using the confidential information. You may disclose confidential information if required by law, court, or other governmental order, but you must provide prior written notice to Noam in a reasonable manner and, to the extent possible, make reasonable efforts to limit the scope of disclosure, including assisting us in opposing disclosure requests.',
    block16:
      '(b) Security. You must implement reasonable and appropriate measures to help safeguard your access to and use of the Service. If you discover any vulnerabilities or violations related to your use of the Service, you must promptly contact Noam and provide details of the vulnerability or violation.',
    block17:
      '((c) Processing of Personal Data. If you use the Service to process personal data, you must provide legally sufficient privacy statements and obtain necessary consents for processing such data, and you warrant to us that you handle such data in accordance with applicable law.',
    block18:
      '(a) Termination; Suspension. These terms will be effective from your first use of the Service and will remain in effect until terminated. You may terminate these terms at any time for any reason by discontinuing use of the Service and Content. We may terminate these terms with prior notice for any reason. We may immediately terminate these terms by notifying you if you materially breach Section 2 (Usage Requirements), Section 5 (Confidentiality, Security, and Data Protection), Section 8 (Dispute Resolution), or Section 9 (General Terms), or if our relationship with any third-party technology provider beyond our control changes, or for compliance with law or government requests. We may suspend your access to the Service if you fail to comply with these terms, or if your use poses a security risk to us or any third party, or if we suspect your use is fraudulent or may expose us or any third party to liability.',
    block19:
      '(b) Effects of Termination. Upon termination, you will cease using the Service and promptly return or destroy any confidential information as directed by us. The provisions of these terms that by their nature should survive termination or expiration, including but not limited to Sections 3 and 5-9, shall survive.',
    block2:
      'These Terms of Use apply to your use of Noam\'s services, including our application programming interfaces, software, tools, developer services, data, documentation, and website (collectively referred to as the "Services"). By using our Services, you agree to abide by these terms. Our Privacy Policy explains how we collect and use personal information.',
    block20:
      "(a) Indemnification. You will defend, indemnify, and hold us, our affiliates, and our personnel harmless from and against any claims, losses, and expenses (including attorneys' fees) arising out of or related to your use of the Service, including your Content, your use of products or services related to the Service, and your violation of these terms or applicable law.",
    block21:
      '(b) Disclaimers. The Service is provided "as is." To the extent permitted by law, we and our affiliates and licensors make no representations or warranties of any kind regarding the Service and make no warranties, including but not limited to warranties of merchantability, fitness for a particular purpose, satisfactory quality, non-infringement, and quiet enjoyment, and any warranties arising out of course of dealing or usage of trade. We do not warrant that the Service will be uninterrupted, accurate, or error-free, or that any Content will be secure, not lost, or not altered.',
    block22:
      '(c) Limitation of Liability. Neither we, our affiliates, nor our licensors will be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, loss of reputation, loss of use, loss of data, or other intangible losses, even if we have been advised of the possibility of such damages. Under these terms, our total liability will not exceed the Fees you paid to the Service in the twelve (12) months preceding the claim or one hundred US dollars ($100), whichever is greater. The limitations in this section apply to the maximum extent permitted by applicable law.',
    block23:
      'The Terms and your use of the Services are governed by the laws of the United States, except for the U.S. conflict of laws rules. Your use of the Application may also be subject to other local, state, national or international laws. Any legal action or proceeding relating to these Terms will be brought exclusively in the courts of the United States, and you agree to submit to the personal jurisdiction of such courts.',
    block24:
      "(a) Relationship of the Parties. Noam and you are independent contractors, and neither party has the power to represent or bind the other party or assume obligations for the other party without the other party's prior written consent.",
    block25:
      '(b) Brand Usage. You may not use the name, logos, or trademarks of Noam or any of its affiliates without our prior written consent.',
    block26:
      'If any provision of these terms is determined to be invalid, illegal, or unenforceable, the remaining provisions will remain in full force and effect.',
    block3:
      'If you are under 18 years old, you must obtain permission from your parents or legal guardians to use the Service. If you are using the Service on behalf of another person or entity, you must be authorized to accept these terms on their behalf. You must provide accurate and complete information to register for an account. You may not provide your access credentials or account to anyone outside of your organization, and you are responsible for all activities conducted using your credentials.',
    block4:
      '(a) Use of Service. You may access the Service under these terms, and we grant you a non-exclusive right to use the Service. When using the Service, you will comply with these terms and all applicable laws. We and our affiliates own all rights, titles, and interests in the Service.',
    block5:
      '(b) Feedback. We welcome feedback, comments, ideas, suggestions, and improvements. If you provide any such content, we may use it without any restrictions and without compensation to you.',
    block6:
      '(c) Restrictions. You may not: (1) use the Service in a manner that infringes, misappropriates, or violates any rights of others; (2) reverse engineer, decompile, disassemble, translate, or otherwise attempt to discover the source code or underlying components of the Service models, algorithms, and systems (unless such restrictions are prohibited by applicable law); (3) use the output of the Service to develop models competing with Noam; (4) extract data or output from the Service using any automated or programming methods unless permitted through the API, including scraping, web harvesting, or web data extraction; (5) represent the output of the Service as artificially generated when it is not, or otherwise violate our usage policies; (6) purchase, sell, or transfer API keys without our prior consent; or (7) provide us with any personal information of children under 13 years old or applicable age of digital consent. You will comply with any rate limits and other requirements in our documentation.',
    block7:
      '(d) Third-Party Services. Any third-party software, services, or other products associated with the Service are governed by their own terms, and we are not responsible for third-party products.',
    block8:
      '(a) Your Content. You may provide input ("Input") to the Service and receive output ("Output") generated and returned based on the Input (collectively referred to as "Content"). Between the parties, and to the extent permitted by applicable law, you own all Input. Noam may use Content to provide and maintain the Service, comply with applicable laws, and enforce our policies. You are responsible for the Content, including ensuring that it does not violate any applicable laws or these terms.',
    block9:
      '(b) Accuracy. Artificial intelligence and machine learning are rapidly evolving fields of research. We continuously strive to improve our service to make it more accurate, reliable, secure, and beneficial. Given the probabilistic nature of machine learning, using our service may result in incorrect outputs in certain cases, which may not accurately reflect real individuals, places, or facts. You should appropriately assess the accuracy of any output based on your use case, including by manually reviewing outputs.',
    subTitle1: 'Registration and Access',
    subTitle10: 'Severability',
    subTitle2: 'Usage Requirements',
    subTitle3: 'Content',
    subTitle4: 'Fees and Payment',
    subTitle5: ' Confidentiality, Security, and Data Protection',
    subTitle6: 'Term and Termination',
    subTitle7: 'Indemnification; Disclaimers; Limitation of Liability',
    subTitle8: 'Governing Law and Jurisdiction',
    subTitle9: 'General Terms',
    title: 'Terms of Service',
    updateTime: 'Updated: March 15, 2024',
  },
  trialModal: {
    btn: 'Get Started Now（Only $0.99）',
    chat: 'ChatPDF',
    desc1: 'After your trial, you will be charged an annual fee of $180',
    desc2: 'Cancel Anytime',
    focus: 'Focusing',
    hover: 'Hover translation',
    image: 'Image translation',
    installBtn: 'Install now to receive your gift',
    memo: 'Favorites management',
    pdf: 'PDF parallel translation',
    realtime: 'Instant translation',
    select: 'Word selection translation',
    title: 'Welcome gift',
    trialText: '7-Day Trial',
    video: 'Video translation',
    videoSummary: 'Video summary',
    web: 'Parallel Translation',
    webSummary: 'Web summary',
  },
  upgradeModal: {
    btn: 'Upgrade Now',
    chat: {
      free: "You've reached the ChatPDF limit",
      pro: "You've reached the ChatPDF limit for this month",
    },
    contactStr: 'Please wait for the next reset, or contact us at contact@noam.tools.',
    limitAlertStr: "You've reached your free plan limit. Upgrade to continue.",
    more: 'View Plans',
    pageLimit: {
      free: "You've reached the PDF page limit",
    },
    title: 'Reminder',
    upgradeAlertStr: "You've reached your free plan limit. Upgrade to continue.",
    upload: {
      free: "You've reached your PDF translation limit",
      pro: "You've reached your PDF translation limit for this month",
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Join Now',
      label: 'New User Benefits:',
      remain: 'Only 30 left',
      text: 'Only 100 Spots Available! Grab Yours Now!',
    },
  },
  aiPdfTranslator: {
    title: 'Free AI PDF Translator: Translate PDF with Comparison in any Languages',
    desc: 'Easily translate PDF files to any languages with AI. Compare original and translated text side by side, fast and free.',
    keywords: 'GPT-4、AI Assistant、Translation、Summary、Focus、ChatPDF、Memo、efficiency',
    sourceToTarget: {
      title: 'Free PDF Translation Tool: translate {{source}} to {{target}} for free',
      desc: 'Translate your PDF files from any source language to your preferred language for free. Fast, accurate, and secure PDF translation powered by advanced AI.',
    },
    headerIntroduce: {
      title: 'Noam: More Than Just Online Translation',
      introduce1: {
        title: 'Noam · PDF Reader',
        desc: '✨Side-by-side translation + AI Q&A. Quickly and accurately translate PDFs into your target language. Freely ask questions about the content to gain a deeper understanding of your PDF files.',
      },
      introduce2: {
        title: 'Noam · Side-by-side Translation Extension',
        desc: '👏Solve all your webpage translation needs:',
        detail1: {
          title: 'Webpage Translation: ',
          desc: 'Side-by-side bilingual view.',
        },
        detail2: {
          title: 'Word Translation: ',
          desc: 'One-click quick translation.',
        },
        detail3: {
          title: 'Instant Translation: ',
          desc: 'Translate words or sentences instantly.',
        },
        detail4: {
          title: 'Image Translation: ',
          desc: 'Replace images with translated ones.',
        },
        detail5: {
          title: 'Video Translation: ',
          desc: 'Bilingual subtitles for better viewing.',
        },
        footer: 'Experience more AI-powered reading features for smarter translation!',
      },
    },
    subtitle: 'PDF Translate Online For Free',
    introduce: {
      module1: {
        detail1: {
          title: 'Real-Time Side-by-Side PDF Translation',
          desc1: 'Instantly display original and translated content in a synchronized, side-by-side layout',
          desc2: 'Effortlessly compare both versions with synchronized scrolling',
          desc3: 'Maintain identical formatting for a consistent reading experience',
        },
        detail2: {
          title: 'Accurate Content Alignment and Verification',
          desc1: 'Perfect alignment between source and translated text for easy verification',
          desc2: 'Every segment of content matches precisely across both versions',
          desc3: 'Quickly spot and resolve translation discrepancies for reliable results',
        },
      },
      module2: {
        detail1: {
          title: 'Multiple Advanced AI Models for Precise Translation',
          desc1: 'Select from leading AI models to match your translation requirements',
          desc2: 'Ensure optimal results for various document types and industries',
          desc3: 'Flexible model options provide tailored solutions for every scenario',
        },
        detail2: {
          title: 'Advanced AI Translation for Every Content Type',
          desc1: 'Our powerful AI model ensures high accuracy and natural language understanding',
          desc2: 'Handles technical, academic, and creative documents with ease',
          desc3: 'Delivers reliable results for all your translation needs',
          desc4: 'Intelligent adaptation to different content types for optimal performance',
        },
      },
      module3: {
        detail1: {
          title: 'Intelligent Document Interaction',
          desc1: 'Effortlessly chat with your PDF, and presentation files using advanced AI',
          desc2: 'Instantly ask questions about document content and receive accurate answers',
          desc3: 'Quickly generate concise summaries for lengthy documents',
        },
        detail2: {
          title: 'Deep Content Analysis and Seamless Integration',
          desc1: 'Extract key information and analyze complex data with AI-powered understanding',
          desc2: 'Gain insights into technical, academic, or creative materials',
          desc3: 'Seamlessly integrates with our PDF Translator for a complete document management solution',
        },
      },
      module4: {
        detail1: {
          title: 'Beyond PDF Translation: All-in-One Webpage Translation Solution',
          desc: 'Discover our powerful side-by-side translation extension designed for every online reading scenario.',
          desc1: 'Webpage Translation: Enjoy bilingual content with a synchronized side-by-side view',
          desc2: 'Word Translation: Instantly translate highlighted words with a single click',
          desc3: 'Instant Translation: Translate any text or sentence on the spot for quick understanding',
          desc4: 'Image Translation: Automatically replace original images with translated versions',
          desc5: 'Video Translation: Watch videos with bilingual subtitles for an enhanced experience',
        },
      },
    },
    question: {
      title: 'Frequently Asked Questions',
      answer1: {
        title: 'Is Noam PDF Translator free to use for PDF translation?',
        content: 'Yes, you can translate PDFs for free with Sider PDF Translator! We offer a free quota of 5,000 tokens, which is sufficient to translate most PDF documents commonly found on the market. If you need to translate larger files or require advanced features, you can choose to upgrade to our premium plans for even more capabilities.',
      },
      answer2: {
        title: 'How accurate is Noam PDF Translator?',
        content: 'Noam PDF Translator provides highly accurate translations by utilizing advanced AI technology and deeply understanding the context of your documents. While no automated translation is flawless, our side-by-side display allows you to easily review and refine every translation, ensuring the final result meets your quality expectations. Experience reliable and precise PDF translation with Noam.',
      },
      answer3: {
        title: 'Can I translate scanned PDFs?',
        content: 'Yes, you can translate scanned PDFs with our built-in OCR (Optical Character Recognition) technology. Our system automatically extracts text from scanned documents and image-based PDFs, then translates the content for you. This ensures that even non-editable or image-only PDFs can be accurately translated.',
      },
      answer4: {
        title: 'How long does translation take?',
        content: 'Translation is fast and efficient—most documents are processed within seconds to a few minutes, depending on their length and complexity. For example, a standard 10-page PDF usually takes less than 2 minutes to translate. Enjoy quick turnaround times for all your document translation needs!',
      },
      answer5: {
        title: 'Can I keep the side-by-side view for reading?',
        content: 'Yes, you can always read your documents side-by-side. This layout allows you to compare the original and translated content easily, ensuring a smooth and efficient reading experience.',
      },
    },
    freeTrial: 'Free Trial',
    toLanguage: {
      title: '{{lang}} PDF AI Translation Pairs',
      item: '{{source}} to {{target}}',
    },
  },
  aiPdfTranslate: {
    header: {
      features: 'Features',
      pricing: 'Pricing',
      faq: 'FAQ',
      blog: 'Blog',
      button: 'Translate Now'
    },
    hero: {
      pill: 'AI-Powered PDF Translator',
      title: 'Free PDF Translator',
      to: 'to',
      desc: 'Instant, accurate translations that preserve original layout. Noam AI supports OCR and side-by-side views.',
      upload: {
        title: 'Upload your PDF',
        highlight: 'Click to browse',
        desc: 'or drag & drop',
        max: 'Max',
      },
      model: 'GPT-4 & Claude',
      support: 'OCR Support',
      free: 'Free Trial',
      translated: 'Translated by Noam',
      complete: 'Translation Complete',
    },
    ticker: {
      pdf: 'PDF Translation',
      ocr: 'OCR Technology',
      format: 'Format Retention',
      multi: 'Multi-Language',
      side: 'Side-by-Side',
      chat: 'Chat with PDF',
      web: 'Web Translation',
      secure: 'Secure & Private',
    },
    comparison: {
      title: 'Why Choose Noam AI?',
      desc: 'Stop struggling with copy-paste translation. Experience the difference between standard tools and our AI-powered context-aware translation.',
      bad: {
        title: 'Standard Translation',
        head: 'Lost Formatting & Context',
        text1: 'Error: Layout broken. Images misplaced.',
        text2: 'Text overlaps and fonts are inconsistent. Difficult to read and unprofessional...'
      },
      dump: {
        title: 'Plain Text Dump'
      },
      good: {
        title: 'Noam AI Translation',
        sub: 'Perfect Formatting, Context Aware',
        tag: 'Perfect Result',
      },
    },
    showcase: {
      kicker: 'SUPPORTED DOCUMENTS',
      title1: 'Any Document',
      title2: 'Any Language',
      note: 'Handle technical, academic, and creative documents with ease.',
      carousel1: 'Art',
      carousel2: 'Architecture',
      carousel3: 'Academic journal',
      carousel4: 'Medicine',
      carousel5: 'Finance',
      carousel6: 'Law',
      carousel7: 'Contract',
      carousel8: 'Policy',
    },
    features: {
      title1: 'More Than Just Translation',
      title2: "It's a Revolution",
      big: {
        title: 'Advanced AI Models (GPT-4, Claude)',
        desc: 'Select from leading AI models to match your translation requirements. Ensure optimal results for various document types.',
      },
      line1: 'Input: Technical Paper.pdf',
      line2: 'Detecting Language: English...',
      line3: 'Model: GPT-4o (High Precision)',
      line4: 'Translation Complete (99% Accuracy)',
      grid1: {
        title: 'OCR Support',
        desc: 'Extract and translate text from scanned PDFs and images instantly.',
      },
      grid2: {
        title: 'High-Res Export',
        desc: 'Download your translated documents in PDF format with original layout.',
      },
      grid3: {
        title: 'Side-by-Side Comparison',
        desc: 'Synchronized scrolling to compare original and translated text.',
      }
    },
    testimonials: {
      kicker: 'LOVED BY USERS',
      title: 'What Our Users Say',
      review1: {
        role: 'Researcher',
        content: 'Noam AI saved me hours on translating academic papers. The side-by-side view is incredibly helpful for verifying technical terms.',
      },
      review2: {
        role: 'Global Marketer',
        content: "The best PDF translator I've used. It keeps the original formatting perfectly, which is crucial for our marketing decks.",
      },
      review3: {
        role: 'Legal Consultant',
        content: 'Accurate and fast. I use it for contract translations and the OCR feature for scanned docs works flawlessly.',
      },
    },
    cta: {
      title: 'Ready to Break Language Barriers?',
      desc: 'Join 10,000+ users and start translating your documents with Noam AI today.',
      button: 'Start Translating for Free',
      hint: '',
    },
    languagePairs: {
      title: 'English PDF AI Translation Pairs',
      desc: 'Popular translation directions supported by Noam AI',
    },
    footer: {
      about: 'About Us',
      privacy: 'Privacy Policy',
      contact: 'Contact Support'
    }
  }
}
export default EN_TRANSLATION
